import React from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import {
    SettingsOutlinedIcon,
    AssignmentOutlinedIcon,
    PeopleIcon,
    PersonAddAlt1OutlinedIcon
} from 'icons/materialIcons';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import PowerOutlinedIcon from '@mui/icons-material/PowerOutlined';
import DoNotDisturbAltOutlinedIcon from '@mui/icons-material/DoNotDisturbAltOutlined';

const TeamSubteamMembersSidenav = ({ onMenuItemClick, selectedItem }) => {
    const navigate = useNavigate();
    const { subteamId } = useParams();
    const listItemStyle = {
        padding: '2px 6px',
        whiteSpace: 'nowrap',
        minHeight: '40px',
        cursor: 'pointer',
        borderRadius: '8px',
        width: '100%',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)'
        }
    };

    const listItemTextStyle = {
        margin: 0,
        '& .MuiTypography-root': {
            fontSize: '0.75rem',
            fontWeight: 600,
            color: "#4f4f4f",
            whiteSpace: 'nowrap'
        }
    };

    const iconStyle = {
        minWidth: '32px',
        marginRight: 0.5
    };

    const menuItems = [
        { id: 'editMembers', label: 'Edit Members', icon: PersonAddAlt1OutlinedIcon },
        { id: 'general', label: 'General', icon: SettingsOutlinedIcon },
        { id: 'restrictions', label: 'Restrictions', icon: DoNotDisturbAltOutlinedIcon },
        { id: 'templateAutoAssign', label: 'Template Auto Assign', icon: AssignmentOutlinedIcon },
        { id: 'integrations', label: 'Integrations', icon: PowerOutlinedIcon },
        { id: 'viewMembers', label: 'View Members', icon: PeopleIcon }
    ];

    return (
        <Box
            sx={{
                display: { xs: 'none', sm: 'block' },
                backgroundColor: '#fff',
                borderRadius: '8px 0 0 8px',
                height: '100%',
                overflow: 'hidden',
            }}
        >
            <Box sx={{ marginTop: 2, width: '100%', paddingLeft: 0, paddingRight: 0 }}>
                <List sx={{ padding: 0, overflow: 'visible', width: '100%', margin: 0 }}>
                    {menuItems.map((item) => {
                        const IconComponent = item.icon;
                        const handleClick = () => {
                            if (item.id === 'viewMembers') {
                                // Navigate to team members page filtered by subteam
                                navigate(`/team/members?subteamId=${subteamId}`);
                            } else {
                                onMenuItemClick(item.id);
                            }
                        };
                        return (
                            <ListItem
                                key={item.id}
                                onClick={handleClick}
                                sx={{
                                    ...listItemStyle,
                                    paddingTop: '1px',
                                    paddingBottom: '1px',
                                    backgroundColor: selectedItem === item.id ? 'rgba(0, 0, 0, 0.08)' : 'transparent',
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.08)',
                                        borderRadius: '8px'
                                    },
                                    '& .MuiListItem-secondaryAction': {
                                        right: '4px'
                                    }
                                }}
                                secondaryAction={
                                    item.id === 'viewMembers' ? (
                                        <LaunchOutlinedIcon sx={{ fontSize: 16, color: '#828282', marginLeft: 1 }} />
                                    ) : null
                                }
                            >
                                <ListItemIcon sx={iconStyle}>
                                    <IconComponent sx={{ fontSize: 20 }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={item.label}
                                    sx={{
                                        ...listItemTextStyle,
                                        flex: '1 1 auto',
                                        minWidth: 0,
                                        ...(item.id === 'viewMembers' && {
                                            '& .MuiTypography-root': {
                                                ...listItemTextStyle['& .MuiTypography-root'],
                                                overflow: 'visible',
                                                textOverflow: 'clip'
                                            }
                                        })
                                    }}
                                />
                            </ListItem>
                        );
                    })}
                </List>
            </Box>
        </Box>
    );
};

export default TeamSubteamMembersSidenav;

